export const segmentsTypeList = [
  {
    value: "AT01",
    label: "ATEM",
  },
  {
    value: "COF01",
    label: "COF-CONSUMIDOR FINAL",
  },
  {
    value: "COF02",
    label: "COF-CONTRATADO",
  },
  {
    value: "PBB",
    label: "POSBB-POSTOS BANDEIRA BRANCA",
  },
  {
    value: "POB",
    label: "POS-POSTOS OUTRAS BANDEIRAS",
  },
  {
    value: "PTBB",
    label: "PTBB-PONTAO BANDEIRA",
  },
  {
    value: "PTAT",
    label: "PTAT-PONTAO ATEM",
  },
  {
    value: "TRR",
    label: "TRR-TRR",
  },
  {
    value: "TRRNI",
    label: "TRRNI-TRRNI",
  },
];

export const getLabelSegmentTypeList = (segmentValue: string) => {
  return segmentsTypeList.find(
    (segmentType) => segmentType.value === segmentValue
  )?.label;
};
